"use strict";

require("core-js/modules/es.weak-map.js");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ScreenReaderModeMessage = exports.GetScreenReaderMode = void 0;
require("core-js/modules/web.dom-collections.iterator.js");
var _react = _interopRequireWildcard(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
const GetScreenReaderMode = _ref => {
  let {
    userContext,
    localStorageKey = 'PetSureScreenReaderMode'
  } = _ref;
  const storageValue = localStorage.getItem(localStorageKey);
  return userContext && userContext.screenReaderMode || storageValue || false;
};
exports.GetScreenReaderMode = GetScreenReaderMode;
GetScreenReaderMode.propTypes = {
  // eslint-disable-next-line react/forbid-prop-types
  userContext: _propTypes.default.any,
  localStorageKey: _propTypes.default.string
};
const ScreenReaderModeMessage = _ref2 => {
  let {
    userContext,
    onScreenReaderModeChange = () => {},
    localStorageKey = 'PetSureScreenReaderMode'
  } = _ref2;
  const [screenReaderModeActive, setScreenReaderMode] = (0, _react.useState)(GetScreenReaderMode({
    userContext,
    localStorageKey
  }));
  const ToggleScreenReaderMode = () => {
    const newMode = !screenReaderModeActive;
    if (newMode) {
      localStorage.setItem(localStorageKey, 'true');
    } else {
      localStorage.removeItem(localStorageKey);
    }
    setScreenReaderMode(newMode);
    onScreenReaderModeChange(newMode);
  };
  return /*#__PURE__*/_react.default.createElement("div", {
    className: "sr-only"
  }, screenReaderModeActive ? /*#__PURE__*/_react.default.createElement("span", null, "Screen reader mode is active.") : /*#__PURE__*/_react.default.createElement("span", null, "This application supports screen reader mode. Would you like to switch this on?"), /*#__PURE__*/_react.default.createElement("button", {
    type: "button",
    onClick: () => ToggleScreenReaderMode()
  }, "Switch screen reader mode ", screenReaderModeActive ? 'off' : 'on'));
};
exports.ScreenReaderModeMessage = ScreenReaderModeMessage;
ScreenReaderModeMessage.propTypes = {
  // eslint-disable-next-line react/forbid-prop-types
  userContext: _propTypes.default.any,
  onScreenReaderModeChange: _propTypes.default.func,
  localStorageKey: _propTypes.default.string
};